import { azureConstants } from './constants/azureConstants';

const getUserUsageMetric = () => {
	return {
		type: azureConstants.GetUserUsageMetricsRequest
  };
};

export const azureAction = {
	getUserUsageMetric
}